(() => {

const GIFT_VARIANT = 51644786704679;
const COLLECTION_HANDLE = "premium-rashi-collection";

let premiumProducts = [];

async function loadPremiumProducts() {
  if (premiumProducts.length) return premiumProducts;

  const res = await fetch(`/collections/${COLLECTION_HANDLE}/products.json?limit=250`);
  const data = await res.json();

  premiumProducts = data.products.map(p => p.id);

  return premiumProducts;
}

async function getCart() {
  return fetch('/cart.js').then(r => r.json());
}

async function addGift() {

  const ids = await loadPremiumProducts();

  const cart = await getCart();

  const hasBracelet = cart.items.some(item =>
    ids.includes(item.product_id)
  );

  if (!hasBracelet) return;

  const hasGift = cart.items.some(item =>
    item.variant_id == GIFT_VARIANT
  );

  if (hasGift) return;

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type':'application/json'
    },
    body: JSON.stringify({
      id: GIFT_VARIANT,
      quantity:1
    })
  });

  location.reload();
}

async function removeGift() {

  const ids = await loadPremiumProducts();

  const cart = await getCart();

  const hasBracelet = cart.items.some(item =>
    ids.includes(item.product_id)
  );

  const gift = cart.items.find(item =>
    item.variant_id == GIFT_VARIANT
  );

  if (hasBracelet) return;

  if (!gift) return;

  await fetch('/cart/change.js', {
    method:'POST',
    headers:{
      'Content-Type':'application/json'
    },
    body: JSON.stringify({
      id: gift.key,
      quantity:0
    })
  });

  location.reload();
}

document.addEventListener('submit', function(e){

  if(!e.target.closest('product-form')) return;

  setTimeout(addGift, 100);

});

document.addEventListener('cart:updated', function(){

  queueMicrotask(removeGift);

});

})();